module.exports = __webpack_public_path__ + "media/campus-2.0ce6c2fa.mp4";